module.exports = __webpack_public_path__ + "img/fuwuxiangmu_jpg3_fwsxq.a9e038c4.png";